import en from './en'
import nl from './nl'

export default {
  en: en,
  nl: nl
}
